import { jsx as _jsx } from 'react/jsx-runtime.js';
import AccountIdentifier from './AccountIdentifier/index.js';
import TwoStepLogin from './TwoStepLogin/index.js';
import TwoStepRegistration from './TwoStepRegistration/index.js';
import TwoStepResetPassword from './TwoStepResetPassword/index.js';
import TwoStepResetPasswordSuccess from './TwoStepResetPasswordSuccess/index.js';
import AppleUpdateEmail from './AppleUpdateEmail/index.js';
import CVUploadModal from '../../../components/RegistrationSuccessModal/index.js';
export const twoStepViews = {
    accountIdentifier: _jsx(AccountIdentifier, {}),
    login: _jsx(TwoStepLogin, {}),
    registration: _jsx(TwoStepRegistration, {}),
    resetPassword: _jsx(TwoStepResetPassword, {}),
    resetPasswordSuccess: _jsx(TwoStepResetPasswordSuccess, {}),
    cvUploadModal: _jsx(CVUploadModal, {}),
    appleUpdateEmail: _jsx(AppleUpdateEmail, {}),
};
//# sourceMappingURL=twoStepViews.js.map